<script>
import  {store} from  '../store'
// const App =()=>import('../@App'
const DashboardV3 =()=>import('../pages/Dashboard-v3.vue')
const ExtraProfile =()=>import('../pages/Extra-profile.vue')
const Bienvenido =()=>import('../pages/PageBienvenido')
const Link =()=>import('../pages/PageLink')
const ComisionChip =()=>import('../pages/PageComisionChip')
const ComisionEquipo =()=>import('../pages/PageComisionEquipo')
const EntregaChip =()=>import('../pages/PageEntregaChip')
const EntregaEquipo =()=>import('../pages/PageEntregaEquipo')
const EntregaDetalleChip =()=>import('../pages/PageEntregaDetalleChip')
const EntregaDetalleChip2 =()=>import('../pages/PageEntregaDetalleChip2')
const EntregaDetalleEquipo =()=>import('../pages/PageEntregaDetalleEquipo')
const Personal =()=>import('../pages/PagePersonal')
const PagoPersonal =()=>import('../pages/PagePagoPersonal')
const PagoPersonalResponsable =()=>import('../pages/PagePagoResponsable.vue')
const EstadoCuenta =()=>import('../pages/PageEstadoCuenta')
const Login =()=>import('../pages/PageLogin')
const DefaultContainerVue =()=>import('../DefaultContainer')
const routes = [

  { path: '/login', component: Login },
 
      { 
       beforeEnter: ((to, from, next) => {
         
        next(store.state.auth);
       
      }),
    
    path: '/',  
    redirect: '/login',
    name: 'Facturacion', 
    component: DefaultContainerVue,
    children: [
       { path: '/bienvenido', component: Bienvenido },
       { path: '/inicio', component: DashboardV3 },
       { path: '/personal',  component: Personal },
       { path: '/links',  component: Link },
       { path: '/comisiones/chip', component: ComisionChip },
       { path: '/comisiones/equipo', component: ComisionEquipo },
       { path: '/entregas/chip', component: EntregaChip },
       { path: '/entregas/chip/:modal', component: EntregaChip },
       { path: '/entregas/equipo', component: EntregaEquipo },
       { path: '/entrega-detalle/chip/:dni/:chip_inicial/:chip_final', component: EntregaDetalleChip },
       { path: '/entrega-detalle/chips/:chip', component: EntregaDetalleChip2 },
       { path: '/entrega-detalle/chips/:chip/:btn_regresar', component: EntregaDetalleChip2 },
       { path: '/entrega-detalle/equipo/:imei', component: EntregaDetalleEquipo },
       { path: '/reporte/pago-responsable', component: PagoPersonalResponsable },
       { path: '/reporte/pago-personal', component: PagoPersonal },
       { path: '/reporte/pago-personal/estado-cuenta/:mes/:anio/:dni/:vendedor', component: EstadoCuenta },
       { path: '/detalle-pago/:mes/:anio/:dni/:vendedor', component: EstadoCuenta },
       { path: '/perfil', component: ExtraProfile },
    ]
  }
]
    

export default routes;
</script>
